module.exports = __webpack_public_path__ + "media/images/emblems/Courtepin2-coat_of_arms-2877113797bfa1e16641390e144a061e.svg";